import { Input } from "@/src/components/universalInput";
import { assuranceAffiliations, Patient } from "@/src/data/allTypes";
import { communes } from "@/src/data/communes";
import { USER } from "@/src/data/globalVariables";
import { nationalities } from "@/src/data/nationalities";
import { wilayas } from "@/src/data/wilayas";
import moment from "moment";
import { useState } from "react";

export function SimplifiedPatientIdentityForm({
  initialValue,
  onChange,
}: {
  initialValue: Patient;
  onChange: (patient: Patient) => void;
}) {
  let [patient, setPatient] = useState<Patient>(initialValue);
  const [age, setAge] = useState<number | undefined>(undefined);

  function onPatientChange(newValue: Patient) {
    setPatient(newValue);
    onChange(newValue);
  }

  return (
    <div id="patient_form" className="grid c1 gap15">
      <Input
        name="N° d'identification (NI)"
        type="text"
        value={patient.nin}
        onChange={(newValue) => {
          onPatientChange({ ...patient, nin: newValue });
        }}
      ></Input>

      <Input
        name="Nom"
        type="text"
        isRequired={true}
        value={patient.lastName}
        onChange={(newValue) => {
          onPatientChange({ ...patient, lastName: newValue });
        }}
      ></Input>

      <Input
        name="Prénom"
        type="text"
        isRequired={true}
        value={patient.firstName}
        onChange={(newValue) => {
          onPatientChange({ ...patient, firstName: newValue });
        }}
      ></Input>

      <Input
        name="Sexe"
        isRequired={true}
        type="chips"
        options={[
          {
            value: "homme",
            label: "Homme",
          },
          {
            value: "femme",
            label: "Femme",
          },
        ]}
        value={patient.sex}
        onChange={(newValue) => {
          onPatientChange({ ...patient, sex: newValue });
        }}
      ></Input>
      <Input
        key={`${age} age`}
        name="Age (années)"
        type="number"
        value={
          age || patient.birth
            ? moment().diff(moment(patient.birth), "years")
            : undefined
        }
        onBlur={(newValue) => {
          setAge(newValue);
          onPatientChange({
            ...patient,
            birth: moment().subtract(newValue, "years").format("YYYY-01-01"),
          });
        }}
        onChange={(newValue) => {}}
      ></Input>
      <Input
        key={`${patient.birth} birth`}
        name="Date de naissance"
        type="date"
        isRequired={true}
        value={
          patient.birth ? moment(patient.birth).format("YYYY-MM-DD") : null
        }
        onBlur={(newValue) => {
          onPatientChange({
            ...patient,
            birth: !moment(newValue).isValid()
              ? ""
              : moment(newValue).format("YYYY-MM-DD"),
          });
          setAge(moment().diff(moment(newValue), "years"));
        }}
        onChange={(newValue) => {}}
      ></Input>

      <Input
        name="N° Tel"
        type="text"
        isRequired={USER.get()?.speciality?.name?.includes("infantile")}
        value={patient.phoneNumber}
        onChange={(newValue) => {
          onPatientChange({ ...patient, phoneNumber: newValue });
        }}
      ></Input>

      <Input
        name="Nom de jeune fille"
        type="text"
        value={patient.maidenName}
        onChange={(newValue) => {
          onPatientChange({ ...patient, maidenName: newValue });
        }}
      ></Input>

      <Input
        name="Nationalité"
        type="select"
        value={patient.nationality}
        isRequired={USER.get()?.speciality?.name?.includes("infantile")}
        options={nationalities.map((nationality) => {
          return { value: nationality, label: nationality };
        })}
        onChange={(newValue) => {
          onPatientChange({ ...patient, nationality: newValue });
        }}
      ></Input>
      <Input
        name="Wilaya"
        type="select"
        value={patient.wilaya}
        options={wilayas.map((wilaya) => {
          return { value: wilaya, label: wilaya };
        })}
        onChange={(newValue) => {
          onPatientChange({ ...patient, wilaya: newValue });
        }}
      ></Input>

      <Input
        name="Groupage"
        type="select"
        options={[
          { value: "A+", label: "A+" },
          { value: "A-", label: "A-" },
          { value: "B+", label: "B+" },
          { value: "B-", label: "B-" },
          { value: "AB+", label: "AB+" },
          { value: "AB-", label: "AB-" },
          { value: "O+", label: "O+" },
          { value: "O-", label: "O-" },
        ]}
        value={patient.bloodType}
        onChange={(newValue) => {
          onPatientChange({ ...patient, bloodType: newValue });
        }}
      ></Input>

      <Input
        name="اللقب"
        type="text"
        value={patient.lastNameAr}
        onChange={(newValue) => {
          onPatientChange({ ...patient, lastNameAr: newValue });
        }}
      ></Input>
      <Input
        name="الإسم"
        type="text"
        value={patient.firstNameAr}
        onChange={(newValue) => {
          onPatientChange({ ...patient, firstNameAr: newValue });
        }}
      ></Input>
      
      <h3 className="mtop20">Assurances</h3>
      <Input
        name="Affiliation"
        type="select"
        options={Object.values(assuranceAffiliations)}
        value={patient.assuranceAffiliation}
        onChange={(newValue) => {
          onPatientChange({ ...patient, assuranceAffiliation: newValue });
        }}
      ></Input>
      <Input
        name="N° sécurité sociale"
        type="text"
        value={patient.socialSecurityNumber}
        onChange={(newValue) => {
          onPatientChange({ ...patient, socialSecurityNumber: newValue });
        }}
      ></Input>
    </div>
  );
}
